import React, { Component } from 'react';

import cx from 'classnames';
import TranslatedCopy from '../../intl/translated-copy';
import { disablePersistentLoginPopup } from '../../../redux/actions';

class PersistentLogin extends Component {
  render() {
    const {
      hiddeCTA,
      isBanner,
      onlyMessage,
      openModalLogin,
    } = this.props;
    const isPopup = !isBanner;

    const componentClass = cx({
      'PersistentLogin': true,
      'PersistentLogin--onlyMessage': onlyMessage,
      'PersistentLogin--popup': isPopup,
      'PersistentLogin--isFormBanner': hiddeCTA,
    });

    const iconClass = cx({
      'Icon Icon--clockTimeBack': true,
      'PersistentLogin-icon': true,
      'PersistentLogin-icon--popup': isPopup,
      'PersistentLogin-icon--onlyMessage': onlyMessage,
      'PersistentLogin-icon--hiddeCTA': hiddeCTA,
    });

    const paragraphClass = cx({
      'PersistentLogin-paragraph': true,
      'PersistentLogin-paragraph--popup': isPopup,
    });

    const titleClass = cx({
      'PersistentLogin-title': true,
      'PersistentLogin-title--onlyMessage': onlyMessage,
      'PersistentLogin-title--popup': isPopup,
    });

    const descriptionClass = cx({
      'PersistentLogin-description': true,
      'PersistentLogin-description--onlyMessage': onlyMessage,
      'PersistentLogin-description--popup': isPopup,
    });

    const closeBtnClass = cx({
      'Icon Icon--xThin': true,
      'PersistentLogin-closeBtn': true,
    });

    const copyTitle = hiddeCTA ? 'BKN_PASSENGERS_PERSISTENT_MESSAGE_NAME' : 'PROFILE_PERSISTENT_MESSAGE_TITLE';
    const nameTitle = hiddeCTA ? localStorage.getItem('firstName') : '';
    const copyDescription = hiddeCTA ? 'BKN_PASSENGERS_PERSISTENT_MESSAGE_DESCRIPTION' : 'PROFILE_PERSISTENT_MESSAGE_DESCRIPTION';

    return (
      <article
        className={ componentClass } >
        <div className={ 'PersistentLogin-container' } >
          { !onlyMessage &&
              <span
                className={ closeBtnClass }
                onClick={ this.closePopup } />
          }
          <span className={ iconClass } />
          <div className={ paragraphClass } >
            { hiddeCTA &&
                <span className='PersistentLogin-name' >
                  { `${ nameTitle }, ` }
                </span>
            }
            <TranslatedCopy
              className={ titleClass }
              copyID={ copyTitle }
              spaceAfter={ true } />
            <TranslatedCopy
              copyID={ copyDescription }
              className={ descriptionClass }
              spaceAfter={ true } />
            { !hiddeCTA &&
                <TranslatedCopy
                  className='PersistentLogin-ctaLink'
                  copyID='PROFILE_PERSISTENT_MESSAGE_CTA'
                  onClick={ openModalLogin } />}
          </div>
        </div>
      </article>
    );
  }

  closePopup = () => {
    const { dispatch } = this.props;
    dispatch(disablePersistentLoginPopup());
  }
}

export default PersistentLogin;